import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import { articles } from "../content/blog/manifest.generated";

const BlogPostPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const { t, i18n } = useTranslation();
  const article = articles.find((a) => a.slug === slug);

  const formatDate = (iso: string) =>
    new Date(iso).toLocaleDateString(i18n.language, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  if (!article) {
    return (
      <div className="mt-8 font-helveticaNeue w-full">
        <p>{t("blog.notFound")}</p>
        <Link
          to="/blog"
          className="text-blue-700 dark:text-blue-400 hover:text-white dark:hover:text-white hover:bg-blue-700"
        >
          ← {t("blog.backToBlog")}
        </Link>
      </div>
    );
  }

  return (
    <div className="mt-8 font-helveticaNeue w-full">
      <Link
        to="/blog"
        className="text-blue-700 dark:text-blue-400 hover:text-white dark:hover:text-white hover:bg-blue-700"
      >
        ← {t("blog.backToBlog")}
      </Link>

      <article className="mt-6">
        <h1 className="text-2xl font-bold">{article.title}</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          {t("blog.publishedOn")} {formatDate(article.date)}
        </p>
        <div className="blog-content mt-6 flex flex-col gap-4">
          <ReactMarkdown
            components={{
              h1: ({ node, ...props }) => (
                <h1 className="text-2xl font-bold mt-4" {...props} />
              ),
              h2: ({ node, ...props }) => (
                <h2 className="text-xl font-bold mt-4" {...props} />
              ),
              h3: ({ node, ...props }) => (
                <h3 className="text-lg font-bold mt-4" {...props} />
              ),
              a: ({ node, ...props }) => (
                <a
                  {...props}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-700 dark:text-blue-400 hover:underline"
                />
              ),
              ul: ({ node, ...props }) => (
                <ul className="list-disc list-inside" {...props} />
              ),
              ol: ({ node, ...props }) => (
                <ol className="list-decimal list-inside" {...props} />
              ),
              code: ({ node, ...props }) => (
                <code
                  className="bg-gray-100 dark:bg-gray-800 px-1 rounded text-sm"
                  {...props}
                />
              ),
              pre: ({ node, ...props }) => (
                <pre
                  className="bg-gray-100 dark:bg-gray-800 p-3 rounded overflow-x-auto text-sm"
                  {...props}
                />
              ),
            }}
          >
            {article.content}
          </ReactMarkdown>
        </div>
      </article>
    </div>
  );
};

export default BlogPostPage;
